import React from "react";
import "../PrivacyPolicy/PrivacyPolicyPage.css";

function TermsOfServicePage() {
  return (
    <main className="privacy-page">
      <div className="privacy-page-container">
        {/* Header */}
        <div className="privacy-page-header">
          <h1 className="privacy-page-title">Terms of Service</h1>
          <p className="privacy-page-subtitle">
            These terms govern your use of Reppi, including our website,
            services, and text (SMS) messaging program.
          </p>
          <p className="privacy-page-last-updated">Last updated: 07/23/2026</p>
        </div>

        <div className="privacy-page-content">
          <div className="privacy-page-policy-content">
            <section className="privacy-page-policy-section">
              <h2>Acceptance of Terms</h2>
              <div className="privacy-page-policy-text">
                <p>
                  By accessing or using Reppi's website and services, you agree
                  to be bound by these Terms of Service and our{" "}
                  <a href="/privacy" className="privacy-page-email-link">
                    Privacy Policy
                  </a>
                  . If you do not agree with these terms, please do not use our
                  services.
                </p>
              </div>
            </section>

            <section className="privacy-page-policy-section">
              <h2>Use of Our Services</h2>
              <div className="privacy-page-policy-text">
                <p>
                  Reppi provides a platform for training, verification, and
                  related business services. You agree to use our services only
                  for lawful purposes and in accordance with these terms. You
                  are responsible for the accuracy of the information you
                  provide and for maintaining the confidentiality of your
                  account credentials.
                </p>
              </div>
            </section>

            <section className="privacy-page-policy-section">
              <h2>SMS/Text Messaging Terms</h2>
              <div className="privacy-page-policy-text">
                <p>
                  Opting in to text messages is optional and is not a condition
                  of purchasing, activating, or receiving any service. If you
                  choose to provide your mobile number and opt in, you agree to
                  receive text (SMS) messages from Reppi, including a link to
                  complete your welcome survey and related follow-up messages.
                  Your participation in our messaging program is subject to the
                  following terms:
                </p>
                <ul>
                  <li>
                    <strong>Program description:</strong> Messages are sent to
                    deliver welcome survey links and related follow-up
                    communications.
                  </li>
                  <li>
                    <strong>Message frequency:</strong> Message frequency
                    varies. You will typically receive a message when a welcome
                    survey link is sent to you, along with occasional related
                    follow-up messages.
                  </li>
                  <li>
                    <strong>Message and data rates:</strong> Message and data
                    rates may apply, depending on your mobile carrier and plan.
                    Reppi is not responsible for any charges from your carrier.
                  </li>
                  <li>
                    <strong>Opting out:</strong> You can cancel the SMS service
                    at any time by replying STOP to any message. After you send
                    STOP, we will send a confirmation message and then stop
                    sending you text messages.
                  </li>
                  <li>
                    <strong>Help:</strong> For help, reply HELP to any message
                    or contact us at{" "}
                    <a
                      href="mailto:help@reppi.co"
                      className="privacy-page-email-link"
                    >
                      help@reppi.co
                    </a>
                    .
                  </li>
                  <li>
                    <strong>Privacy:</strong> No mobile information will be
                    shared with third parties or affiliates for marketing or
                    promotional purposes. For more detail on how we handle your
                    information, see our{" "}
                    <a href="/privacy" className="privacy-page-email-link">
                      Privacy Policy
                    </a>
                    .
                  </li>
                  <li>
                    <strong>Supported carriers:</strong> Carriers are not liable
                    for delayed or undelivered messages.
                  </li>
                </ul>
              </div>
            </section>

            <section className="privacy-page-policy-section">
              <h2>Intellectual Property</h2>
              <div className="privacy-page-policy-text">
                <p>
                  All content, features, and functionality of our services,
                  including text, graphics, logos, and software, are the
                  property of Reppi or its licensors and are protected by
                  applicable intellectual property laws. You may not reproduce,
                  distribute, or create derivative works without our prior
                  written consent.
                </p>
              </div>
            </section>

            <section className="privacy-page-policy-section">
              <h2>Disclaimers and Limitation of Liability</h2>
              <div className="privacy-page-policy-text">
                <p>
                  Our services are provided "as is" and "as available" without
                  warranties of any kind, whether express or implied. To the
                  fullest extent permitted by law, Reppi shall not be liable for
                  any indirect, incidental, or consequential damages arising
                  from your use of our services.
                </p>
              </div>
            </section>

            <section className="privacy-page-policy-section">
              <h2>Changes to These Terms</h2>
              <div className="privacy-page-policy-text">
                <p>
                  We may update these Terms of Service from time to time to
                  reflect changes in our practices or legal requirements. We
                  will notify you of any material changes by posting the updated
                  terms on our website and updating the "Last updated" date.
                  Your continued use of our services after any changes indicates
                  your acceptance of the updated terms.
                </p>
              </div>
            </section>

            <section className="privacy-page-policy-section">
              <h2>Contact Us</h2>
              <div className="privacy-page-policy-text">
                <p>
                  If you have any questions about these Terms of Service, please
                  contact us at:
                </p>
                <div className="privacy-page-contact-info">
                  <p>
                    <strong>Email:</strong>{" "}
                    <a
                      href="mailto:help@reppi.co"
                      className="privacy-page-email-link"
                    >
                      help@reppi.co
                    </a>
                  </p>
                  <p>
                    <strong>Subject:</strong> Terms of Service Inquiry
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
}

export default TermsOfServicePage;
